import ReactModal, { Styles } from 'react-modal';

import { purple1 } from 'approot/shared/styles/colours.style';
import { ModalBaseCss } from 'lib/modal/modal.constants';
import * as Styled from './activity-builder-offline-modal.style';

const modalStyles: Styles = {
  content: {
    textAlign: 'center',
    borderRadius: '8px',
    padding: '12px 16px',
    backgroundColor: `${purple1}`,
    boxShadow: '0px 4px 6px 0px rgba(0, 0, 0, 0.16)',
    maxHeight: '50px',
    maxWidth: '190px',
    zIndex: 111,
    border: 'none',
  },
  overlay: {
    ...ModalBaseCss.overlay,
  },
};

const ActivityBuilderOfflineModal = ({ isVisible }: { isVisible: boolean }) => {
  return (
    <ReactModal
      isOpen={isVisible}
      style={modalStyles}
      contentLabel="You are currently offline. Trying to connect"
    >
      <Styled.ActivityBuilderOfflineModalContent>
        Trying to connect...
      </Styled.ActivityBuilderOfflineModalContent>
    </ReactModal>
  );
};

export default ActivityBuilderOfflineModal;
